module.exports = __webpack_public_path__ + "static/SolarPower_White.4d2e1405.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SolarPower_White.png
// module id = 586
// module chunks = 213534597649335